import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'evergreen-ui'
const BtnDefault = ({
  isLoading, children, dispatch, icon, ...rest
}) => (
    <Button
      {...rest}
      isLoading={isLoading}
      iconBefore={icon && !isLoading ? icon : null}>
      {children}
    </Button>
  )

const mapStateToProps = ({ loading }) => {
  return { isLoading: loading.isLoading }
}

export default connect(mapStateToProps)(BtnDefault)